/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum TextDividerUniqueSymbols {
    DoubleN = '^',
    SingleN = '#',
    Br = '%',
}
